<template>
  <div>
    <CardSlider
      cardType="ImageCard"
      :title="title"
      :generalCardLabel="$t('general.labels.project')"
      :cards="countryCards"
      white
      @onCardClick="showModal"
    />

    <CountryModal
      :show="!!countryContents[currentProjectIndex]"
      v-bind="countryContents[currentProjectIndex]"
      :imagePath="`${$t('translation.' + currentPage)}_project-cover-${currentProjectIndex + 1}`"
      :projectAmount="countryCards.length"
      :currentProjectIndex="currentProjectIndex"
      @onClose="showModal(-1)"
      @onNavigate="toProject"
    />
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import CardSlider from "./CardSlider.vue";
import CountryModal from "../general/CountryModal.vue";

const props = defineProps({
  title: String,
  currentPage: String,
});

const { t, tm } = useI18n();
const currentProjectIndex = ref(-1);

const countryContents = computed(() => tm("countryModalData"));

const countryCards = computed(() => {
  return countryContents.value.map((content, i) => ({
    ...content.cardContent,
    imagePath: `${t('translation.' + props.currentPage)}_project-card-${i + 1}`,
  }));
});

function showModal(cardIndex) {
  currentProjectIndex.value = cardIndex;
}

function toProject(navigation) {
  currentProjectIndex.value = currentProjectIndex.value + navigation;
}
</script>

<style lang="scss" scoped></style>
